<template>
    <!-- 拍卖结果 -->
    <div class="auctionList">
        <!-- 拍卖中 -->
        <div v-if="meetList.length > 0">
            <div class="auction">
                <div
                    class="auction-item"
                    v-for="(item, index) in meetList"
                    :key="index"
                    @click="jumpSession('/session/' + item.sessionCode + waterLink,index)"
                >
                   
                        <div class="item-top">
                            <div :class="'item-icon' + item.status"></div>
                            <div class="txt">{{ item.name }}<span></span></div>
                        </div>
                        <div class="item-brief">
                            <div
                                class="brief"
                                v-for="(a, b) in item.extraInfo"
                                :key="b"
                            >
                                <div class="brief-icon">
                                    <img
                                        v-if="b == 0"
                                        src="@/assets/img/icon_list_time_light@2x.png"
                                    />
                                    <img
                                        v-if="b == 1"
                                        src="@/assets/img/icon_list_cheng_light@2x.png"
                                    />
                                </div>
                                <template v-if="a.picUrl == 'listicon_date'">
                                    <span>{{a.text}}<template v-if="item.OnlineAuction == 1"> 网络拍卖</template></span>
                                </template>
                                <template v-else>{{a.text}}</template>
                            </div>
                        </div>
                        <div class="speSwiper">
                            <div class="swiper-container">
                                <ul class="swiper-wrapper">
                                    <li
                                        class="swiper-slide"
                                        v-for="(m, i) in item.specialsList"
                                        :key="i"
                                    >
                                        <div class="imgCenter">
                                            <!-- <img src="@/assets/img/avator.jpeg" alt="" />coverPic -->
                                            <img :src="m.coverPic" alt="" />
                                            <span class="HiPic" v-if="m.isHD > 0"></span>
                                            <template >
                                                <template v-if="m.live_info.have_live > 0">
                                                    <span class="live" v-if="m.live_info.live_status == 2"></span>
                                                    <span class="liveReview" v-if="m.live_info.live_status == 4 && m.live_info.have_review == 1">直播回放</span>
                                                </template>
                                            </template>
                                        </div>
                                        <h3 class="name">{{ m.name }}</h3>
                                        <div class="tags">
                                            <template v-for="(label, k) in m.live_info
                                                    .label_list">
                                                <span :key="k" v-if="label.name=='视频直播'" class="tag videoLive"></span>
                                                <span :key="k" v-if="label.name == '同步拍'" class="tag tbPai"></span>
                                                <span :key="k" v-if="label.name == '限时拍'" class="tag xsPai">限时拍</span>
                                                <span :key="k" v-if="label.name == '图文直播'" class="tag imgLive"></span>
                                            </template>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                 
                </div>
            </div>
            <div class="noMore" v-if="noMore">
                <span>我是有底线的</span>
            </div>
        </div>
        <emptyPage v-else></emptyPage>
    </div>
</template>

<script>
import { getMeetList } from "@/api/meeting";
import emptyPage from "@/components/empty/emptyPage";
import {
    scMdFunc,
} from "@/assets/js/scData";
export default {
    props: ["organCode", "Year","showWater"],
    data() {
        return {
            waterLink:'',
            meetList: [], //拍卖会列表
            noMore: false, //我是有底线的
            finished: false,
            param: {
                // citys: "mm",
                organCode: this.$route.params.organCode,
                year: this.Year+'',
            },
            page: 1,
        };
    },
    mounted() {},
    created() {
        this.waterLink = this.showWater ? '?from=cloud' : ''
        this.getMeet();
    },
    components: {
        emptyPage,
    },
    methods: {
        getMeet() {
            let that = this;
            getMeetList(this.param).then((res) => {
                if (res.code == 0) {
                    let dataList = res.data.sessionList;
                    dataList.forEach(function (item) {
                        that.meetList.push(item);
                    });
                    this.$forceUpdate();
                }
            });
        },
        onLoad() {
            this.getMeet();
        },
        jumpSession(e, i) {
            scMdFunc('allClick', {
                cur_page: '32',
                cur_moudle: '32-4',
                cur_button: '32-4-'+ (Number(i) + 1),
            })
            window.location.href = e
        },
    },
};
</script>

<style lang="scss" scoped>
@import url("../../../assets/css/reset.css");
@import url("../../../assets/css/swiper.css");
.page {
    width: 18.75rem;
    margin: 0 auto;
}
/* 头部 */

.tab-top {
    width: 18.75rem;
    height: 2.4rem;
    background: #ffffff;
    padding: 0 0.75rem 0 1.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.05rem;
}
.tab-top .tabs {
    display: flex;
    font-size: 0.75rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
}
.tab-top .tabs .tab {
    height: 2.4rem;
    margin-right: 1.5rem;
    line-height: 2.4rem;
}
.tabs .tab.active {
    color: #18bd6f;
    border-bottom: 0.15rem solid #18bd6f;
}
.tab-top .select-item {
    display: flex;
    align-items: center;
}
.select-item .col-line {
    width: 0.05rem;
    height: 0.8rem;
    box-shadow: -0.02rem 0rem 0rem 0rem #dddee3;
}
.select-item span {
    font-size: 0.7rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
    margin-left: 0.75rem;
    margin-right: 0.15rem;
}
.select-item .select-icon {
    width: 0.65rem;
    height: 0.65rem;
    /* background: rgba(255, 255, 255, 0.01); */
    background-image: url(../../../assets/img/screen.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
/* 拍卖中 */
.auction {
    width: 18.75rem;
}
.auction-item {
    /* padding: 0.75rem; */
    background-color: #fff;
    margin-bottom: 0.25rem;
}
.auction-item .item-top {
    display: flex;
    align-items: center;
    padding: 0.75rem 0.75rem 0 0.75rem;
}
/* icon数字 5已结拍 4拍卖中 3待预展 2预展中 1待拍卖 */
.auction-item .item-icon5 {
    width: 1.9rem;
    height: 0.7rem;
    background-image: url(../../../assets/img/icon_list_tag_grey@2x.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}
.auction-item .item-icon4 {
    width: 1.9rem;
    height: 0.7rem;
    background-image: url(../../../assets/img/icon_list_tag_red@2x.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}
/* 这个待预展暂时没有图片 */
.auction-item .item-icon3 {
    width: 1.9rem;
    height: 0.7rem;
    background-image: url(../../../assets/img/icon_list_tag_gree.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}
.auction-item .item-icon2 {
    width: 1.9rem;
    height: 0.7rem;
    background-image: url(../../../assets/img/icon_list_tag_green.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}
.auction-item .item-icon1 {
    width: 1.9rem;
    height: 0.7rem;
    background-image: url(../../../assets/img/icon_list_tag_green@2x.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}
.auction-item .txt {
    width: 15.25rem;
    height: 1.1rem;
    font-size: 0.8rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
    line-height: 1.1rem;
    margin-left: 0.1rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
}
.auction-item .txt span {
    color: #18bd6f;
}
.auction-item .item-brief {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 0.5rem;
    padding: 0 0.75rem 0 0.75rem;
}
.item-brief .brief {
    display: flex;
    align-items: center;
}
.item-brief .brief span {
    /* width: 7.8rem; */
    height: 0.9rem;
    font-size: 0.65rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #969696;
    line-height: 0.9rem;
}
.item-brief .brief-icon {
    width: 0.65rem;
    height: 0.65rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.3rem;
}
.item-brief .brief-icon img {
    width: 100%;
    height: 100%;
}

.speSwiper {
    margin-top: 0.25rem;
    background: #ffffff;
    padding: 0.75rem;
}
.swiper-container {
}
.swiper-wrapper {
    overflow-x: scroll;
}
.swiper-wrapper::-webkit-scrollbar {
    display: none;
}
.speSwiper .swiper-slide {
    width: 4.75rem;
    margin-right: 0.4rem;
}
.speSwiper .swiper-slide .imgCenter {
    height: 6.25rem;
    background: #d8d8d8;
    border-radius: 0.2rem;
    overflow: hidden;
    position: relative;
}
.speSwiper .swiper-slide .imgCenter img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.speSwiper .swiper-slide .imgCenter .live {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1.1rem;
    background: #18bd6f url(../../../assets/img/live.gif) no-repeat;
    background-size: cover;
}
.speSwiper .swiper-slide .imgCenter .liveReview {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1.1rem;
    background: rgba(0, 0, 0, 0.85);
    font-size: 0.65rem;
    line-height: 1.1rem;
    color: #ffffff;
    text-align: center;
}
.speSwiper .swiper-slide .imgCenter .HiPic {
    background: url(../../../assets/img/icon_list_HDpic_26@2x.png) no-repeat;
    position: absolute;
    top: 0;
    right: 0;
    width: 1.7rem;
    height: 0.8rem;
    background-size: 100% 100%;
}
.speSwiper .swiper-slide .name {
    margin-top: 0.4rem;
    font-size: 0.65rem;
    line-height: 0.9rem;
    color: #969696;
    height: 1.8rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.speSwiper .swiper-slide .tags {
    margin-top: 0.3rem;
    font-size: 0;
}
.speSwiper .swiper-slide .tag {
    display: inline-block;
    height: 0.8rem;
    background-repeat: no-repeat;
    background-size: contain;
    margin-right: 0.3rem;
}
.speSwiper .swiper-slide .tag:last-child {
    margin-right: 0;
}
.speSwiper .swiper-slide .videoLive {
    width: 2.4rem;
    background-image: url(../../../assets/img/icon_video_live.png);
}
.speSwiper .swiper-slide .imgLive {
    width: 2.4rem;
    background-image: url(../../../assets/img/icon_img_live.png);
}
.speSwiper .swiper-slide .tbPai {
    width: 1.8rem;
    background-image: url(../../../assets/img/icon_tbpai.png);
}
.speSwiper .swiper-slide .xsPai {
    border: 1px solid #eee;
    color: #999;
    font-size: 0.45rem;
    padding: 0.03rem 0.1rem;
    height: auto;
   
}
.loading{padding:1rem 0;}
</style>